"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildLabelWithIndexIfNeeded = exports.isAllStringsFalsy = exports.buildStringWithDelimiter = void 0;
var buildStringWithDelimiter = function (words, delimiter) {
    if (words === void 0) { words = []; }
    return words
        .map(function (word) { return (word != null && word !== '' && word) || ''; })
        .join(delimiter);
};
exports.buildStringWithDelimiter = buildStringWithDelimiter;
var isAllStringsFalsy = function () {
    var strings = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        strings[_i] = arguments[_i];
    }
    return strings.every(function (str) { return str == null || str === ''; });
};
exports.isAllStringsFalsy = isAllStringsFalsy;
var buildLabelWithIndexIfNeeded = function (_a) {
    var index = _a.index, label = _a.label;
    if (label == null) {
        return '';
    }
    return index != null ? index + ". " + label : label;
};
exports.buildLabelWithIndexIfNeeded = buildLabelWithIndexIfNeeded;
